import { unauthenticatedError } from './CommonMiddlewares'
import { ExtendedData, Http } from './Http'
import { tokenMiddleware } from './LexonHttp'

/**
 * Cliente para endpoints de LexOn que leen sus datos del parámetro `json`
 * de un POST form-urlencoded (p. ej. ListContactAllController).
 * Los `params` se serializan como `json=<JSON.stringify(params)>`.
 */
class LexonFormHttp extends Http {
  protected serializeBody(params?: Record<string, unknown>): URLSearchParams {
    return new URLSearchParams({ json: JSON.stringify(params ?? {}) })
  }
}

const lexonFormHttp = new LexonFormHttp()

function formTokenMiddleware(data: ExtendedData): Promise<ExtendedData> {
  data.headers = { ...data.headers, 'Content-type': 'application/x-www-form-urlencoded' }
  return tokenMiddleware(data)
}

lexonFormHttp.addMidleware('onRequest', formTokenMiddleware)
lexonFormHttp.addMidleware('onError', unauthenticatedError)

export default lexonFormHttp
